import type { ThemeConfig } from "antd";

/** Palette del mockup v2 (variabili CSS --primary, --nav, --ok, ...). */
export const palette = {
  bg: "#F8F5EF",
  card: "#FFFFFF",
  sunk: "#F3EFE7",
  hair: "#E2DED3",
  fg: "#16202B",
  heading: "#141F2C",
  muted: "#5C6670",
  primary: "#1A4470",
  primarySoft: "#E3ECF5",
  nav: "#0B1B2E",
  navFg: "#C9D3DD",
  ok: "#2E6B4F",
  okSoft: "#DCE8E2",
  warn: "#9A6200",
  warnSoft: "#F6E9CF",
  bad: "#B3261E",
  badSoft: "#F7DEDB",
  crit: "#6E1A3A",
  critSoft: "#EED8E0",
  secS: "#1A4470",
  secH: "#7A5C1E",
  secE: "#2E6B4F",
  secX: "#7E95A1",
};

export const fonts = {
  sans: '"Manrope Variable", Manrope, system-ui, -apple-system, "Segoe UI", sans-serif',
  mono: '"IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, monospace',
};

export const theme: ThemeConfig = {
  token: {
    colorPrimary: palette.primary,
    colorSuccess: palette.ok,
    colorWarning: palette.warn,
    colorError: palette.bad,
    colorInfo: palette.primary,
    colorBgLayout: palette.bg,
    colorText: palette.fg,
    colorBorderSecondary: palette.hair,
    // Contrasto AA (ACS29-F8.3, axe): i grigi derivati da Ant Design (nero al 45% e al 25%) stavano sotto 4,5:1 sul
    // bianco e sul fondo crema, e i fondi dei tag derivati dai colori di stato scuri uscivano grigi. Come Agents Crew.
    colorTextSecondary: palette.muted,
    colorTextTertiary: palette.muted,
    colorTextDescription: palette.muted,
    colorTextPlaceholder: "#6A7178",
    colorSuccessBg: palette.okSoft,
    colorWarningBg: "#FCF4E4",
    colorErrorBg: palette.badSoft,
    colorInfoBg: palette.primarySoft,
    borderRadius: 8,
    fontFamily: fonts.sans,
    fontFamilyCode: fonts.mono,
  },
  components: {
    Layout: { siderBg: palette.nav, triggerBg: palette.nav, headerBg: palette.card, bodyBg: palette.bg },
    Menu: { darkItemBg: palette.nav, darkSubMenuItemBg: palette.nav, darkItemColor: palette.navFg, darkItemSelectedBg: palette.primary },
  },
};

/** CSS globali minimi: il Badge di antd forza il colore del testo, nel menu scuro va ereditato. */
export const globalCss = `
html{--ap-mono:${fonts.mono}}
html,body{margin:0;padding:0;background:${palette.bg};font-family:${fonts.sans};color:${palette.fg};-webkit-text-size-adjust:100%}
code,kbd,pre,.mono{font-family:${fonts.mono}}
.ap-col-resize{position:absolute;top:0;right:-4px;width:9px;height:100%;cursor:col-resize;z-index:2;touch-action:none}
.ap-col-resize::after{content:"";position:absolute;top:25%;bottom:25%;left:4px;width:2px;border-radius:1px;background:transparent;transition:background .15s}
th:hover>.ap-col-resize::after,.ap-col-resize:active::after{background:${palette.primary}}
.ant-menu-dark .nav-badge{color:inherit}
.ant-menu-dark .ant-menu-item:focus,.ant-menu-dark .ant-menu-item:focus-visible{outline:none!important;box-shadow:none!important}
.ap-kpi{display:grid;gap:12px;grid-template-columns:repeat(5,minmax(0,1fr))}
.ap-kpi>:last-child:nth-child(odd){grid-column:auto}
@media (max-width:767px){.ap-kpi{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}.ap-kpi>:last-child:nth-child(odd){grid-column:1/-1}}
`;
